import React from 'react';
import Dropdown from 'react-bootstrap/esm/Dropdown';
import DropdownToggle from '../../../presentation/dropdown/DropdownToggle';
import DropdownMenu from '../../../presentation/dropdown/DropdownMenu';

import arrow2 from '../../../../img/arrow2.gif';
import btn_calendar from '../../../../img/btn_calendar.gif';

const DropdownReportOption = (props) => {

  return (
    <Dropdown alignRight={true}>
      <Dropdown.Toggle hrefValue="" as={DropdownToggle} >
        <>
          {props.toggle}<img src={props.img=='calendar' ? btn_calendar:arrow2} alt="select" align="absmiddle" />
        </>
      </Dropdown.Toggle>
      <Dropdown.Menu as={DropdownMenu} >
        {props.children}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default DropdownReportOption;